<!-- Products Filters Component -->
<div class="products-filters" [class.drawer-mode]="drawerMode">
  <!-- Header with Filters title and Clear All button -->
  <div class="filters-header-main" [ngClass]="drawerMode ? 'p-3' : 'mb-3'">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-filter text-gray-600 mr-2"></i>
        <h2 class="filters-title">Filters</h2>
      </div>
      <div class="header-right">
        <button
          class="clear-all-btn"
          [disabled]="loading || !hasActiveFilters"
          [class.has-filters]="hasActiveFilters"
          (click)="onClearFilters()"
          title="Clear all active filters"
        >
          Clear All
        </button>
      </div>
    </div>
  </div>

  <!-- Scrollable Filter Content Container -->
  <div
    class="filters-content-scroll"
    [ngClass]="drawerMode ? 'drawer-scroll' : 'default-scroll'"
  >
    <!-- Search Section -->
    <div class="search-section" [ngClass]="drawerMode ? 'p-3' : 'mb-4'">
      <div class="search-input-wrapper">
        <p-iconfield iconPosition="left" styleClass="w-full">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input
            pInputText
            [formControl]="filterForm.controls.search"
            placeholder="Search products by name, SKU..."
            [disabled]="loading"
            class="modern-search-input w-full"
          />
        </p-iconfield>
      </div>
    </div>

    <!-- Status Section -->
    <div
      class="filter-section status-section"
      [ngClass]="drawerMode ? 'px-3 pb-4' : 'mb-4'"
    >
      <div class="section-header mb-3">
        <h3 class="filter-section-title">Status</h3>
      </div>

      <p-select
        [options]="statusSelectOptions"
        [formControl]="filterForm.controls.status"
        optionLabel="label"
        optionValue="value"
        placeholder="All statuses"
        [disabled]="loading"
        [showClear]="filterForm.controls.status.value !== 'all'"
        appendTo="body"
        class="w-full"
        styleClass="w-full"
        (onClear)="onStatusClear()"
      />
    </div>

    <!-- Product Group Section -->
    <div
      class="filter-section group-section"
      [ngClass]="drawerMode ? 'px-3 pb-4' : 'mb-4'"
    >
      <div class="section-header mb-3">
        <h3 class="filter-section-title">Product Group</h3>
      </div>

      <p-select
        [options]="productGroups"
        [formControl]="filterForm.controls.productGroupId"
        optionLabel="Name"
        optionValue="ProductGroupId"
        placeholder="Select a group"
        [disabled]="loading || productGroups.length === 0"
        [showClear]="filterForm.controls.productGroupId.value !== null"
        appendTo="body"
        class="w-full"
        styleClass="w-full"
      />
    </div>

    <!-- Counts Summary -->
    @if (counts) {
      <div class="counts-summary" [ngClass]="drawerMode ? 'px-3 pb-4' : 'mb-4'">
        <div class="summary-card p-3 surface-100 border-round">
          <div class="text-sm text-600 mb-2 font-medium">Summary</div>
          <div class="grid">
            <div class="col-6">
              <span class="text-xs text-500">Total:</span>
              <span class="ml-1 font-medium">{{ counts.TotalCount }}</span>
            </div>
            <div class="col-6">
              <span class="text-xs text-500">Active:</span>
              <span class="ml-1 font-medium text-green-600">{{
                counts.ActiveCount
              }}</span>
            </div>
            <div class="col-6">
              <span class="text-xs text-500">Inactive:</span>
              <span class="ml-1 font-medium text-500">{{
                counts.InactiveCount
              }}</span>
            </div>
            <div class="col-6">
              <span class="text-xs text-500">Invalid:</span>
              <span class="ml-1 font-medium text-red-600">{{
                counts.InvalidCount
              }}</span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
